import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Pagination from '../../components/pagination/Pagination';
import AddInterestReportModal from './AddInterestReportModal';
import { groupProps, QuantProps } from '../QuantReport';
import QuantService from '../../../service/quant/Quant';
import { isFinalMonth, userGradeType } from '../../../utils/auth';
import { useModal } from '../../../context/ModalContext';
import { QuantReportItem } from '../../quant/Quant3/Quant3';
import ThemeModal from './ThemeModal';
import DetailInfoModal from '../../quant/Quant3/DetailInfoModal';
import MemoModal from './MemoModal';
import { useUser } from '../../../context/UserContext';
import QuotaService from '../../../service/quota/Quota';
interface Props {
  list: QuantProps[];
  groupList: groupProps[];
  totalCount: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  limit: number;
  getQuantList: () => void;
}

const BLUE_DOWN_KEYS = [
  'appraisal_vs_market_price',
  'bid_vs_public_land_price',
  'lowest_bid_vs_jeonse',
  'nearby_avg_vs_market_price',
  'sale_price_vs_lowest_bid',
] as const;

const RED_UP_KEYS = [
  'real_trade_growth_rate_1y',
  'monthly_rent_vs_loan_interest',
] as const;

const NEUTRAL_KEYS = [
  'jeonse_advantage_3y',
  'wolse_advantage_3y',
  'expected_equity',
] as const;

function ReportContent({
  list,
  groupList,
  totalCount,
  currentPage,
  setCurrentPage,
  limit,
  getQuantList,
}: Props) {
  // const limit = 12;
  const { user } = useUser();
  const { modalDispatch } = useModal();

  const [quotaAccess, setQuotaAccess] = useState(false);
  const [openInterestModal, setOpenInterestModal] = useState(false);
  const [selectedIdx, setselectedIdx] = useState<number | null>(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState<string[]>([]);
  const [openDetailInfoModal, setOpenDetailInfoModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState<QuantProps | null>(null);
  const [openMemoModal, setOpenMemoModal] = useState(false);
  const [selectedMemo, setSelectedMemo] = useState<{
    group: string;
    memo: string;
  } | null>(null);
  const reverseTypeObj: { [key: string]: number } = {
    저평가주: 0,
    공시지가보다낮주: 1,
    전세가보다낮주: 2,
    전세우위주: 3,
    월세우위주: 4,
    평균보다낮주: 5,
    하자없주: 6,
    시세차익주: 7,
    저평가부실채권주: 8,
    소액투자주: 9,
    시세상승주: 10,
    이자보다월세주: 11,
  };

  const themeMap: Record<string, keyof (typeof list)[0]> = {
    저평가주: 'appraisal_vs_market_price',
    공시지가보다낮주: 'bid_vs_public_land_price',
    전세가보다낮주: 'lowest_bid_vs_jeonse',
    전세우위주: 'jeonse_advantage_3y',
    월세우위주: 'wolse_advantage_3y',
    평균보다낮주: 'nearby_avg_vs_market_price',
    시세차익주: 'sale_price_vs_lowest_bid',
    저평가부실채권주: 'appraisal_vs_market_price',
    소액투자주: 'expected_equity',
    시세상승주: 'real_trade_growth_rate_1y',
    이자보다월세주: 'monthly_rent_vs_loan_interest',
  };

  const boldWords = [
    '감정가',
    '입찰가',
    '최저입찰가',
    '전세 우위',
    '월세 우위',
    '시세',
    '매각가',
    '자기자본',
    '실거래 상승율',
    '월세 수익률',
  ];

  const renderDetailTitle = (fullText: string) => {
    const boldWord = boldWords.find((word) => fullText.includes(word));

    if (!boldWord) return fullText;

    const parts = fullText.split(boldWord);

    return (
      <>
        {parts[0]} <span>{boldWord}</span> {parts[1]}
      </>
    );
  };

  function formatKoreanWon(amount: number | string) {
    if (typeof amount === 'string') {
      amount = parseFloat(amount.replace(/,/g, ''));
    }
    if (typeof amount !== 'number' || isNaN(amount) || Math.abs(amount) < 10000)
      return '-';

    const units = [
      { value: 100000000, label: '억 ' },
      { value: 10000, label: '만' },
    ];

    let result = '';
    for (let unit of units) {
      if (amount >= unit.value) {
        const unitCount = Math.floor(amount / unit.value);
        amount %= unit.value;
        result += unitCount + unit.label;
      }
    }

    return result;
  }

  const formatDate = (dateStr: string) => {
    const [dateOnly] = dateStr.split('T');
    const [year, month, day] = dateOnly.split('-');
    return `분석일 ${year.slice(2)}.${month}.${day}`;
  };

  const deleteInterest = async (idx: number) => {
    try {
      await QuantService.deleteInterest(idx);
    } catch (err) {
      console.log(err);
    }
  };

  const handleInterestButton = (idx: number, qh_idx: number, star: boolean) => {
    if (star) {
      const confirmed = window.confirm('관심 리포트에서 삭제하시겠습니까?');
      if (confirmed) {
        deleteInterest(qh_idx);
        getQuantList();
      }
    } else {
      setOpenInterestModal(true);
      setselectedIdx(idx);
    }
  };
  const handleMemoClick = (
    item: QuantProps,
    groupName: string | undefined,
    memo: string | undefined,
  ) => {
    setSelectedMemo({ group: groupName ?? '', memo: memo ?? '' });
    setSelectedItem(item);
    setOpenMemoModal(true);
  };

  const getValue = (list: any[]) => {
    const f = list.find((x) => x.type === 'B');
    return { count: f?.count ?? 0, limit: f?.limit ?? 0 };
  };
  // 서비스 이용권 확인
  const checkQuota = async () => {
    try {
      const res = await QuotaService.count();
      const value = getValue(res.data);
      setQuotaAccess(value.limit > value.count);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    checkQuota();
  }, []);

  return (
    <Box gap={24}>
      {list.length > 0 && (
        <ItemBox>
          {list.map((item, index) => {
            const matchedGroup = (groupList.find(
              (g) => g.group_idx === item.group_idx,
            )?.group ?? '') as string;

            return (
              <ItemMemo key={index}>
                <Item>
                  <ItemHeader>
                    <StarBoxWrap>
                      <StarBox>
                        <img
                          src={
                            item.group_idx
                              ? '/assets/images/icon/star-blue.svg'
                              : '/assets/images/icon/star-gray.svg'
                          }
                          onClick={() => {
                            handleInterestButton(
                              item.quant_idx,
                              item.qh_idx,
                              item.group_idx !== null,
                            );
                          }}
                          alt=""
                        />
                      </StarBox>

                      {item.group_idx !== null && (
                        <StarBox
                          onClick={() =>
                            handleMemoClick(item, matchedGroup, item.memo)
                          }
                        >
                          <img
                            src={
                              item.memo
                                ? '/assets/images/icon/memo_on.svg'
                                : '/assets/images/icon/memo_off.svg'
                            }
                            alt="메모"
                          />
                        </StarBox>
                      )}
                    </StarBoxWrap>

                    <Row gap={8}>
                      <Text size={12} weight={500} color="#37383C9C">
                        {formatDate(item.analysis_time)}
                      </Text>
                      <ReportButton
                        disable={item.is_possible === 0}
                        onClick={() => {
                          const grade = user?.plan_grade;
                          if (!grade) {
                            modalDispatch({
                              type: 'USER_ALERT',
                              payload: 'free',
                            });
                            return;
                          }
                          if (item.is_possible === 0) {
                            modalDispatch({
                              type: 'USER_ALERT',
                              payload: 'local',
                            });
                            return;
                          }
                          if (!quotaAccess) {
                            if (isFinalMonth(user?.plan_end)) {
                              modalDispatch({
                                type: 'USER_ALERT',
                                payload: 'quotaDepletedExpiring',
                              });
                            } else {
                              modalDispatch({
                                type: 'USER_ALERT',
                                payload: 'quotaDepleted',
                              });
                            }
                            return;
                          }
                          const typeNumbers = item.search_category
                            .map((name) => reverseTypeObj[name])
                            .filter((num) => num !== undefined);
                          const strategyText = typeNumbers.join(',');
                          window.open(
                            `/quant/vipreport/${item.quant_idx}/${strategyText}`,
                            '_blank',
                          );
                        }}
                      >
                        리포트보기
                      </ReportButton>
                    </Row>
                  </ItemHeader>

                  <Box gap={8} style={{ alignContent: 'flex-start' }}>
                    <ItemHeader>
                      <BadgeBox>
                        <Category_Badge>
                          <Text size={12} weight={700} color="#FFFFFF">
                            {item.category}
                          </Text>
                        </Category_Badge>
                        {item?.search_category.length > 0 && (
                          <ThemeBadge
                            hasPopover={item?.search_category.length > 1}
                            onClick={() => {
                              if (item.search_category.length === 1) return;

                              setSelectedTheme(item.search_category);
                              setOpenModal(true);
                            }}
                          >
                            <Text size={12} weight={700} color="#FFFFFF">
                              {item?.search_category[0]}
                            </Text>
                            {item?.search_category.length > 1 && (
                              <img
                                src="/assets/images/plus/plus_white.svg"
                                alt="plus"
                                width={14}
                                height={14}
                              />
                            )}
                          </ThemeBadge>
                        )}
                      </BadgeBox>
                    </ItemHeader>
                    <Text size={12} weight={500} color="#37383C9C">
                      {item.caseno} | {item.court}
                    </Text>
                    <Text
                      size={14}
                      weight={700}
                      color="#222222"
                      style={{ textAlign: 'start' }}
                    >
                      {item.region}
                    </Text>
                    <Row gap={4}>
                      {item.tags.map((tag, index) => (
                        <Tag key={index} type={index === 0 ? item.type : 6}>
                          <span>{tag}</span>
                        </Tag>
                      ))}
                    </Row>
                  </Box>

                  <Divider />

                  <Box gap={2}>
                    <Row style={{ justifyContent: 'space-between' }}>
                      <Text size={13} weight={500} color="#616161">
                        예상입찰가
                      </Text>
                      <Text size={16} weight={700} color="#222222">
                        {formatKoreanWon(item.ex_bid_prc)}
                      </Text>
                    </Row>
                    <Row style={{ justifyContent: 'space-between' }}>
                      <Text size={13} weight={500} color="#616161">
                        예상매각가
                      </Text>
                      <Text size={16} weight={700} color="#222222">
                        {formatKoreanWon(item.ex_sale_prc)}
                      </Text>
                    </Row>
                    <Row style={{ justifyContent: 'space-between' }}>
                      <Text size={13} weight={500} color="#616161">
                        예상매매차익
                      </Text>
                      <Text size={16} weight={700} color="#F45551">
                        {formatKoreanWon(item.margin)}
                      </Text>
                    </Row>
                  </Box>

                  <Divider />

                  <Row02 gap={16}>
                    <Text size={14} weight={500} color="#616161">
                      ROI:{' '}
                      <Text size={14} weight={700} color="#008AFF">
                        {item.roi ? item.roi : '-'}%
                      </Text>
                    </Text>
                    <Text size={14} weight={500} color="#616161">
                      ROE:{' '}
                      <Text size={14} weight={700} color="#008AFF">
                        {item.roe ? item.roe : '-'}%
                      </Text>
                    </Text>
                  </Row02>

                  <Divider />

                  <Box gap={2}>
                    {item.search_category.slice(0, 2).map((theme, idx) => {
                      const key = themeMap[theme];
                      if (!key) return null;

                      const value = item[key];
                      const isRate = theme !== '소액투자주';

                      const titleMap: Partial<
                        Record<keyof (typeof list)[0], string>
                      > = {
                        appraisal_vs_market_price: '시세 대비 감정가',
                        bid_vs_public_land_price: '공시지가 대비 입찰가',
                        lowest_bid_vs_jeonse: '전세가 대비 최저입찰가',
                        jeonse_advantage_3y: '최근 6개월 전세 우위 비중',
                        wolse_advantage_3y: '최근 6개월 월세 우위 비중',
                        nearby_avg_vs_market_price: '인근 평균 시세 대비',
                        sale_price_vs_lowest_bid: '최저입찰가 대비 매각가',
                        expected_equity: '예상 자기자본',
                        real_trade_growth_rate_1y: '최근 1년 실거래 상승율',
                        monthly_rent_vs_loan_interest:
                          '대출이자 대비 월세 수익률',
                      };

                      const isBlueDown = BLUE_DOWN_KEYS.includes(key as any);
                      const isRedUp = RED_UP_KEYS.includes(key as any);

                      const textColor = isBlueDown
                        ? '#008AFF'
                        : isRedUp
                          ? '#F45551'
                          : '#222';

                      // return (
                      //   <Row
                      //     key={idx}
                      //     style={{ justifyContent: 'space-between' }}
                      //   >
                      //     <DetailInfoTitle>
                      //       {renderDetailTitle(titleMap[key] ?? '')}
                      //     </DetailInfoTitle>

                      //     <DetailInfoNumber color={textColor}>
                      //       {value ?? '-'}
                      //       {isRate ? '%' : '만원'}
                      //       {showArrowUp && (
                      //         <img
                      //           src="/assets/images/arrow/arrow-up-red-fill.svg"
                      //           alt=""
                      //         />
                      //       )}
                      //       {showArrowDown && (
                      //         <img
                      //           src="/assets/images/arrow/arrow-down-blue-fill.svg"
                      //           alt=""
                      //         />
                      //       )}
                      //     </DetailInfoNumber>
                      //   </Row>
                      // );
                    })}
                    {item.search_category.length && (
                      <MoreButton
                        className={
                          !Array.isArray(item.search_category) ||
                          item.search_category.filter(
                            (v) => v && v !== 'undefined' && v !== 'null',
                          ).length === 0
                            ? 'nodata'
                            : ''
                        }
                        onClick={
                          Array.isArray(item.search_category) &&
                          item.search_category.filter(
                            (v) => v && v !== 'undefined' && v !== 'null',
                          ).length > 0
                            ? () => {
                                setSelectedItem(item);
                                setOpenDetailInfoModal(true);
                              }
                            : undefined
                        }
                      >
                        산출기준 보기
                      </MoreButton>
                    )}
                  </Box>
                </Item>
              </ItemMemo>
            );
          })}
        </ItemBox>
      )}
      {list.length > 0 && (
        <PaginationWrapper>
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(totalCount / limit)}
            onPageChange={(page) => {
              setCurrentPage(page);
            }}
            removeMargin={true}
          />
        </PaginationWrapper>
      )}
      {list.length === 0 && <BlinkBox> 물건이 없습니다.</BlinkBox>}
      {openInterestModal && (
        <AddInterestReportModal
          onClose={() => setOpenInterestModal(false)}
          selectedIdx={selectedIdx}
          mode=""
          getQuantList={getQuantList}
        />
      )}
      {openModal && (
        <ThemeModal
          onClose={() => setOpenModal(false)}
          search_category={selectedTheme}
        />
      )}
      {openDetailInfoModal && selectedItem && (
        <DetailInfoModal
          item={selectedItem as unknown as QuantReportItem}
          selectedThemes={selectedItem.search_category}
          onClose={() => {
            setOpenDetailInfoModal(false);
          }}
        />
      )}
      {openMemoModal && selectedMemo && (
        <MemoModal
          open={openMemoModal}
          onClose={() => setOpenMemoModal(false)}
          group={selectedMemo.group}
          memo={selectedMemo.memo}
          getQuantList={getQuantList}
          onEditInterest={() => {
            setOpenMemoModal(false); // 메모 모달 닫기
            setOpenInterestModal(true); // 관심목록 편집 모달 열기
          }}
          qhIdx={(selectedItem as QuantProps)?.qh_idx ?? 0}
          groupIdx={(selectedItem as QuantProps)?.group_idx ?? 0}
        />
      )}
    </Box>
  );
}

export default ReportContent;

const Box = styled.div<{ gap?: number }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap}px;
`;

const Row = styled.div<{ gap?: number }>`
  /* width: 100%; */
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.gap}px;
  align-items: center;
`;
const Row02 = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: ${(props) => props.gap}px;
  align-items: center;
`;
const Text = styled.span<{ color: string; size: number; weight: number }>`
  font-family: Spoqa Han Sans Neo;
  font-weight: ${(props) => props.weight};
  font-size: ${(props) => props.size}px;
  line-height: 145%;
  letter-spacing: ${(props) => props.size * -0.02}px;
  color: ${(props) => props.color};
`;

const ItemBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-bottom: 24px;
  row-gap: 24px;
  column-gap: 24px;
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  padding: 16px;
  gap: 12px;
  border: 1px solid #e5e8ea;
  background: #ffffff;
`;

const ItemHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  img {
    cursor: pointer;
  }
`;

const ItemMemo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

const MemoBox = styled.div`
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #e5e8ea;
  background-color: #fafafb;
`;

const Memo = styled.div`
  display: block;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;
const Category_Badge = styled.div<{ type?: number }>`
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: center;
  align-items: center;
  border-radius: 9999px;
  padding-top: 2px;
  padding-right: 8px;
  padding-bottom: 2px;
  padding-left: 8px;
  background: #008aff;
  border: 1px solid #008aff;
  width: fit-content;
`;

const R_Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-end;
  align-items: center;
`;

const BtnRP = styled.button<{ disable?: boolean }>`
  border: none;
  background: #70737c14;
  width: 100%;
  border-radius: 8px;
  padding-top: 9px;
  padding-right: 16px;
  padding-bottom: 9px;
  padding-left: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  cursor: ${({ disable }) => (disable ? 'default' : 'pointer')};
  opacity: ${({ disable }) => disable && 0.4};

  span {
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: calc(14px * 0.02);
    color: #616161;
    width: 100%;
    text-align: center;
  }
`;

const BlinkBox = styled.div`
  width: 100%;
  height: 628px;
  gap: 16px;
  padding-top: 24px;
  padding-right: 16px;
  padding-bottom: 72px;
  padding-left: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const Tag = styled.span<{ type: number }>`
  border-radius: 4px;
  padding-top: 2px;
  padding-right: 5px;
  padding-bottom: 2px;
  padding-left: 5px;
  background: ${(props) => {
    switch (props.type) {
      case 1:
        return '#E6F4FF';
      case 2:
        return '#F1FCF8';
      case 3:
        return '#FCF5F1';
      case 4:
        return '#F1EEFF';
      case 5:
        return '#FEEFF4';
      default:
        return '#70737C14';
    }
  }};
  span {
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    font-size: 12px;
    line-height: 145%;
    letter-spacing: calc(12px * -0.05);
    color: ${(props) => {
      switch (props.type) {
        case 1:
          return '#008AFF';
        case 2:
          return '#27A131';
        case 3:
          return '#EC5717';
        case 4:
          return '#836BF1';
        case 5:
          return '#F45551';
        default:
          return '#37383C9C';
      }
    }};
  }
`;

const PaginationWrapper = styled.div`
  padding-top: 24px;
  padding-bottom: 72px;
`;

const BadgeBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const ThemeBadge = styled(Category_Badge)<{ hasPopover: boolean }>`
  background: #d224ca;
  border: none;
  cursor: ${(props) => (props.hasPopover ? 'pointer' : 'default')};
`;

const ReportButton = styled.button<{ disable: boolean }>`
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #008aff;
  cursor: ${({ disable }) => (disable ? 'default' : 'pointer')};
  opacity: ${({ disable }) => disable && 0.4};
  border: none;
  background-color: transparent;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e5e8ea;
`;

const DetailInfoTitle = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: 500;
  font-size: 13px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;

  span {
    font-weight: 700;
    color: #222;
  }
`;

const DetailInfoNumber = styled.div<{ color?: string }>`
  display: flex;
  flex-direction: row;
  gap: 4px;
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  color: ${({ color }) => (color ? color : '#222')};
`;

const MoreButton = styled.div`
  position: relative;
  width: 100%;
  padding: 8px 0;
  border-radius: 4px;
  border: 1px solid #e5e8ea;
  cursor: pointer;
  background-color: transparent;

  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #616161;
  &.nodata {
    cursor: auto;
    background: #fafafb;
    border: 1px solid #e5e8ea;
    color: rgba(55, 56, 60, 0.16);
    &:hover {
      background: #fafafb;
    }
  }
  &:hover {
    background: #eaf2fe;
  }
`;
const StarBoxWrap = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-direction: row;
`;
const StarBox = styled.div`
  padding: 8px;
  border-radius: 50%;
  display: flex;
  &:hover {
    background: rgba(0, 0, 0, 0.09);
  }
`;
